import type { ComposerStore, Prompt } from "./schema"
import { isAttachment } from "./prompt-parts"

export function discardQueueSource(source: ComposerStore["queueSource"]) {
  return source?.submission && !source.submission.retry ? { ...source, discarded: true } : undefined
}

// Editor actions and programmatic draft writes must clear the same hidden
// source when the user removes the final visible content or context item.
export function queueSourceAfterEdit(store: ComposerStore, prompt: Prompt, context = store.context) {
  if (!store.queueSource) return undefined
  const occupied = (parts: Prompt) => parts.some((part) => isAttachment(part) || part.content.trim())
  if ((occupied(store.prompt) || store.context.items.length) && !occupied(prompt) && !context.items.length)
    return discardQueueSource(store.queueSource)
  return store.queueSource
}
